import ReactDOM from 'react-dom';

const getToolTipContainerStyle = (position) => {
    return  {
        top: position.top,
        left: position.left,
        maxWidth: '200px',
        width: 'fit-content',
        height: 'fit-content',
        position: 'absolute',
        backgroundColor: 'white',
        boxShadow: '0 5px 10px 2px rgba(195,192,192,.5)',
        zIndex: 2,
        borderRadius: '5px',
        paddingTop: '5px',
    };
}

const getToolTipRect = (itemRef, offset) => {
    let x = offset? offset.x : 0;
    let y = offset? offset.y : 0;
    let winTop = '';
    let winLeft = '';
    const winW = '160px';
    const winH = `30px`; 
    if (itemRef && itemRef.current) {
      const node = ReactDOM.findDOMNode(itemRef.current);
      const output = node.getBoundingClientRect();
      if (output) {
        winTop = `${output.y - output.height - 10 + y}px`;
        winLeft = `${output.x - 50 + x}px`;
      }
    }
    const rect = {
      top: winTop,
      left: winLeft,
      width: winW,
      height: winH,
    }
    return rect;
}

export default {
    getToolTipContainerStyle,
    getToolTipRect,
};